export default __webpack_public_path__ + "media/images/ig_icon-cc6784d59ce5c65a707b9ee313bbbdab.png";